<template>
  <div class="terminal_result_pane full-height">
    <!-- start: tabs -->
    <div class="tabs-wrapper">
      <span class="tabs-wrapper-title">
        Text
      </span>
      <!-- start: text -->
      <div class="tabs-wrapper-text">
        <pre>{{ result }}</pre>
      </div>
      <!-- end: text -->
    </div>
    <!-- end: tabs -->
  </div>
</template>

<script>
import { defaultOptions } from '@/config/monaco-editor';
import PiEditorResize from '@/mixins/PiEditorResize';
import _ from 'lodash';
import { removeSpace } from '@/utils/helpers';

export default {
  name: 'TerminalResultPane',

  mixins: [PiEditorResize],

  props: {
    command: {
      type: String
    },
/*    database: {
      type: String
    },*/
    result: {
      required: true
      //type: Array
    }
  },

  data() {
    return {
      content: [],
      editorOptions: {
        ...defaultOptions,
        readOnly: true,
        matchBrackets: false,
        contextmenu: false,
        renderLineHighlight: 'none',
        selectionHighlight: false,
        fontSize: 14,
        lineHeight: 16
      },
      tableId: 0,
      tableData: [],
      activeTableRow: null
    };
  },

  watch: {
    result: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) this.content = val;
      }
    }
  },

  methods: {

  }
};
</script>

<style scoped lang="scss">
$height-header: 40px;
$height-footer: 40px;

.terminal_result_pane {
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: scroll;

  .header {
    flex-shrink: 0;
    padding-left: 12px;
    padding-right: 12px;
    background-color: #eee;
    height: $height-header;
    display: flex;
    align-items: center;
  }

  .tabs-wrapper {
    height: 100%;
    min-height: 0;
    flex: 1;
    &-title{
      background-color: #eee;
      height: 36px;
      width: 100%;
      display: block;
      line-height: 36px;
      padding-left: 12px;
    }


    &-text {
      /*&::v-deep .cursor {
        display: none !important;
      }*/
      height: 100%;
      width: 100%;
      pre {
        width: 100%;
        height: 100%;
      }
    }
  }

  .footer {
    flex-shrink: 0;
    height: $height-footer;
    padding-left: 12px;
    padding-right: 12px;
    background-color: #eee;
    display: flex;
    align-items: center;
  }
}
</style>

<style lang="scss">
.tabs-of-terminal-result-pane {
  & > .el-tabs__header {
    margin-right: 0 !important;
  }

  & > .el-tabs__content {
    height: 100%;

    & > .el-tab-pane {
      height: 100%;
      word-wrap: break-word;
    }
  }
}
</style>
